export function addUrlPart(url, paramName, paramValue) {
    if (url.match('/$') == null) {
        url += '/'
    }

    url += paramName + '/'
    if (paramValue != null && paramValue.length > 0)
        url += getFormattedValue(paramValue) + '/'
    return url
}

export function addQueryParameter(queryString, paramName, paramValue) {
    if (queryString.indexOf('?') == -1) {
        queryString += '?'
    } else {
        queryString += '&'
    }
    queryString += paramName + '=' + getFormattedValue(paramValue)
    return queryString
}

export function getFormattedValue(paramValue) {
    return  encodeURIComponent(paramValue)
    // paramValue = String(paramValue)

    // var regex = /[\.\\`׳״&?]/ig
    // var regexWS = /( ){2,}|\+/g
    // return paramValue.replace(regex, '').replace(regexWS, ' ')
}